// extracted by mini-css-extract-plugin
export default {"header":"header_header__Yv1ej","titleRow":"header_titleRow__BuAv-","title":"header_title__sT0PB","right":"header_right__1Ma-T"};